export default __webpack_public_path__ + "static/media/edit.0f06a28a.svg";